module.exports = __webpack_public_path__ + "img/tag-3-4~7.fd03162a.svg";